import { render, staticRenderFns } from "./ExpiringItems.vue?vue&type=template&id=1dcc1a19&"
import script from "./ExpiringItems.vue?vue&type=script&lang=js&"
export * from "./ExpiringItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports